import { render, staticRenderFns } from "./BulkActionsV2.vue?vue&type=template&id=13e8a548&"
import script from "./BulkActionsV2.vue?vue&type=script&lang=js&"
export * from "./BulkActionsV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports